import { type ActionType, createAction } from 'typesafe-actions';

export const toggleAssetSelection = createAction('assets/TOGGLE_ASSET_SELECTION')<string>();
export const toggleAll = createAction('assets/TOGGLE_ALL_SELECTION_REQUESTED')();
export const toggleAllFulfilled = createAction('assets/TOGGLE_ALL_SELECTION_FULFILLED')<string[]>();
export const deleteSelected = createAction('assets/DELETE_SELECTED_REQUESTED')();
export const deleteSelectedPending = createAction('assets/DELETE_SELECTED_PENDING')();
export const deleteAsset = createAction('assets/DELETE_ASSET')<string>();
export const toggleAssetEditing = createAction('assets/TOGGLE_ASSET_EDITING')<string>();
export const toggleSortMenuOpen = createAction('assets/TOGGLE_SORT_MENU_OPEN')();
export const setAssetLocale = createAction('assets/SET_LOCALE')<string>();

export type AssetsActions =
  | ActionType<typeof toggleAssetSelection>
  | ActionType<typeof toggleAll>
  | ActionType<typeof toggleAllFulfilled>
  | ActionType<typeof deleteSelected>
  | ActionType<typeof deleteSelectedPending>
  | ActionType<typeof deleteAsset>
  | ActionType<typeof toggleAssetEditing>
  | ActionType<typeof toggleSortMenuOpen>
  | ActionType<typeof setAssetLocale>;
